import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../svelte-button.svelte';
import DropdownMenu from '../svelte-dropdown-menu.svelte';
import { formatPositionPercent, scheduleSelectAllTextIfFocused } from './shared.ts';

var root = $.from_html(`<span class="ui-symbol-kebab">...</span>`);
var root_1 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button>`, 1);
var root_2 = $.from_html(`<div><div class="ramp-swatch svelte-19kimso"></div> <span class="ramp-position-text svelte-19kimso"> </span> <!></div>`);
var root_3 = $.from_html(`<div class="position-editor svelte-19kimso"><label class="editor-label svelte-19kimso" for="lut-editor-ramp-position"> </label> <input id="lut-editor-ramp-position" type="text" inputmode="decimal" class="pos-input svelte-19kimso"/> <span class="editor-unit svelte-19kimso">%</span></div>`);
var root_4 = $.from_html(`<div class="ramp-section svelte-19kimso"><div class="section-header svelte-19kimso"><div class="section-label svelte-19kimso"> </div> <div class="section-header-actions svelte-19kimso"><!> <!></div></div> <div class="ramp-list svelte-19kimso"></div> <!></div>`);

const $$css = {
	hash: 'svelte-19kimso',
	code: '.ramp-section.svelte-19kimso {display:flex;flex-direction:column;flex:0 0 auto;border-bottom:1px solid var(--color-line);padding:12px 16px;gap:8px;max-height:50%;overflow:auto;}.section-header.svelte-19kimso {display:flex;align-items:center;justify-content:space-between;gap:8px;}.section-header-actions.svelte-19kimso {display:flex;align-items:stretch;gap:8px;flex-shrink:0;}.section-label.svelte-19kimso {font-size:11px;font-weight:600;color:var(--color-muted);text-transform:uppercase;letter-spacing:0.04em;}.ramp-list.svelte-19kimso {display:flex;flex-direction:column;gap:2px;}.ramp-row.svelte-19kimso {display:flex;align-items:center;gap:8px;padding:5px 8px;border-radius:6px;cursor:pointer;border:1px solid transparent;transition:background 0.1s, opacity 0.1s;user-select:none;}.ramp-row.svelte-19kimso:hover {background:color-mix(in srgb, var(--color-text-strong), transparent 95%);}.ramp-row-selected.svelte-19kimso {border-color:var(--color-accent);background:color-mix(in srgb, var(--color-accent), transparent 92%);}.ramp-row-dragging.svelte-19kimso {opacity:0.35;pointer-events:none;}.ramp-row[data-drop-position="before"] {box-shadow:inset 0 3px 0 var(--color-accent);}.ramp-row[data-drop-position="after"] {box-shadow:inset 0 -3px 0 var(--color-accent);}.ramp-swatch.svelte-19kimso {width:48px;height:14px;border-radius:3px;border:1px solid color-mix(in srgb, var(--color-text-strong), transparent 90%);flex-shrink:0;}.ramp-position-text.svelte-19kimso {font-size:11px;color:var(--color-text);font-variant-numeric:tabular-nums;flex:1;}.position-editor.svelte-19kimso {display:flex;align-items:center;gap:8px;padding:6px 2px 2px;}.editor-label.svelte-19kimso {font-size:11px;color:var(--color-muted);min-width:52px;flex-shrink:0;}.editor-unit.svelte-19kimso {font-size:11px;color:var(--color-muted);font-variant-numeric:tabular-nums;min-width:34px;}.pos-input.svelte-19kimso {width:calc(6ch + 16px);box-sizing:content-box;font-size:12px;padding:3px 6px;border:1px solid var(--color-control-border);border-radius:4px;background:var(--color-surface-inset);color:var(--color-text);font-variant-numeric:tabular-nums;text-align:right;}'
};

export default function Lut_editor_ramp_section($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const ramps = $.prop($$props, 'ramps', 23, () => []),
		selectedRamp = $.prop($$props, 'selectedRamp', 7, null),
		selectedRampId = $.prop($$props, 'selectedRampId', 7, null),
		editingRampPositionId = $.prop($$props, 'editingRampPositionId', 7, null),
		rampPositionDraft = $.prop($$props, 'rampPositionDraft', 7, ''),
		draggingRampListIdx = $.prop($$props, 'draggingRampListIdx', 7, null),
		rampListLabel = $.prop($$props, 'rampListLabel', 7, ''),
		addRampLabel = $.prop($$props, 'addRampLabel', 7, ''),
		duplicateRampLabel = $.prop($$props, 'duplicateRampLabel', 7, ''),
		invertRampLabel = $.prop($$props, 'invertRampLabel', 7, ''),
		removeRampLabel = $.prop($$props, 'removeRampLabel', 7, ''),
		rampPositionLabel = $.prop($$props, 'rampPositionLabel', 7, ''),
		rampMenuAriaLabel = $.prop($$props, 'rampMenuAriaLabel', 7, ''),
		maxRampsReached = $.prop($$props, 'maxRampsReached', 7, false),
		canRemoveRamp = $.prop($$props, 'canRemoveRamp', 7, () => false),
		rampSwatchStyle = $.prop($$props, 'rampSwatchStyle', 7, () => ''),
		onAddRamp = $.prop($$props, 'onAddRamp', 7, () => undefined),
		onSelectRamp = $.prop($$props, 'onSelectRamp', 7, () => undefined),
		onStartRampListDrag = $.prop($$props, 'onStartRampListDrag', 7, () => undefined),
		onRemoveRamp = $.prop($$props, 'onRemoveRamp', 7, () => undefined),
		onDuplicateSelectedRamp = $.prop($$props, 'onDuplicateSelectedRamp', 7, () => undefined),
		onInvertSelectedRamp = $.prop($$props, 'onInvertSelectedRamp', 7, () => undefined),
		onBeginRampPositionEdit = $.prop($$props, 'onBeginRampPositionEdit', 7, () => undefined),
		onRampPositionInput = $.prop($$props, 'onRampPositionInput', 7, () => undefined),
		onCommitRampPosition = $.prop($$props, 'onCommitRampPosition', 7, () => undefined),
		onCancelRampPositionEdit = $.prop($$props, 'onCancelRampPositionEdit', 7, () => undefined),
		onRampPositionWheel = $.prop($$props, 'onRampPositionWheel', 7, () => undefined),
		shouldSuppressRampClick = $.prop($$props, 'shouldSuppressRampClick', 7, () => false);

	let rampPositionInputRef = $.state(null);

	var $$exports = {
		get ramps() {
			return ramps();
		},

		set ramps($$value = []) {
			ramps($$value);
			$.flush();
		},

		get selectedRamp() {
			return selectedRamp();
		},

		set selectedRamp($$value = null) {
			selectedRamp($$value);
			$.flush();
		},

		get selectedRampId() {
			return selectedRampId();
		},

		set selectedRampId($$value = null) {
			selectedRampId($$value);
			$.flush();
		},

		get editingRampPositionId() {
			return editingRampPositionId();
		},

		set editingRampPositionId($$value = null) {
			editingRampPositionId($$value);
			$.flush();
		},

		get rampPositionDraft() {
			return rampPositionDraft();
		},

		set rampPositionDraft($$value = '') {
			rampPositionDraft($$value);
			$.flush();
		},

		get draggingRampListIdx() {
			return draggingRampListIdx();
		},

		set draggingRampListIdx($$value = null) {
			draggingRampListIdx($$value);
			$.flush();
		},

		get rampListLabel() {
			return rampListLabel();
		},

		set rampListLabel($$value = '') {
			rampListLabel($$value);
			$.flush();
		},

		get addRampLabel() {
			return addRampLabel();
		},

		set addRampLabel($$value = '') {
			addRampLabel($$value);
			$.flush();
		},

		get duplicateRampLabel() {
			return duplicateRampLabel();
		},

		set duplicateRampLabel($$value = '') {
			duplicateRampLabel($$value);
			$.flush();
		},

		get invertRampLabel() {
			return invertRampLabel();
		},

		set invertRampLabel($$value = '') {
			invertRampLabel($$value);
			$.flush();
		},

		get removeRampLabel() {
			return removeRampLabel();
		},

		set removeRampLabel($$value = '') {
			removeRampLabel($$value);
			$.flush();
		},

		get rampPositionLabel() {
			return rampPositionLabel();
		},

		set rampPositionLabel($$value = '') {
			rampPositionLabel($$value);
			$.flush();
		},

		get rampMenuAriaLabel() {
			return rampMenuAriaLabel();
		},

		set rampMenuAriaLabel($$value = '') {
			rampMenuAriaLabel($$value);
			$.flush();
		},

		get maxRampsReached() {
			return maxRampsReached();
		},

		set maxRampsReached($$value = false) {
			maxRampsReached($$value);
			$.flush();
		},

		get canRemoveRamp() {
			return canRemoveRamp();
		},

		set canRemoveRamp($$value = () => false) {
			canRemoveRamp($$value);
			$.flush();
		},

		get rampSwatchStyle() {
			return rampSwatchStyle();
		},

		set rampSwatchStyle($$value = () => '') {
			rampSwatchStyle($$value);
			$.flush();
		},

		get onAddRamp() {
			return onAddRamp();
		},

		set onAddRamp($$value = () => undefined) {
			onAddRamp($$value);
			$.flush();
		},

		get onSelectRamp() {
			return onSelectRamp();
		},

		set onSelectRamp($$value = () => undefined) {
			onSelectRamp($$value);
			$.flush();
		},

		get onStartRampListDrag() {
			return onStartRampListDrag();
		},

		set onStartRampListDrag($$value = () => undefined) {
			onStartRampListDrag($$value);
			$.flush();
		},

		get onRemoveRamp() {
			return onRemoveRamp();
		},

		set onRemoveRamp($$value = () => undefined) {
			onRemoveRamp($$value);
			$.flush();
		},

		get onDuplicateSelectedRamp() {
			return onDuplicateSelectedRamp();
		},

		set onDuplicateSelectedRamp($$value = () => undefined) {
			onDuplicateSelectedRamp($$value);
			$.flush();
		},

		get onInvertSelectedRamp() {
			return onInvertSelectedRamp();
		},

		set onInvertSelectedRamp($$value = () => undefined) {
			onInvertSelectedRamp($$value);
			$.flush();
		},

		get onBeginRampPositionEdit() {
			return onBeginRampPositionEdit();
		},

		set onBeginRampPositionEdit($$value = () => undefined) {
			onBeginRampPositionEdit($$value);
			$.flush();
		},

		get onRampPositionInput() {
			return onRampPositionInput();
		},

		set onRampPositionInput($$value = () => undefined) {
			onRampPositionInput($$value);
			$.flush();
		},

		get onCommitRampPosition() {
			return onCommitRampPosition();
		},

		set onCommitRampPosition($$value = () => undefined) {
			onCommitRampPosition($$value);
			$.flush();
		},

		get onCancelRampPositionEdit() {
			return onCancelRampPositionEdit();
		},

		set onCancelRampPositionEdit($$value = () => undefined) {
			onCancelRampPositionEdit($$value);
			$.flush();
		},

		get onRampPositionWheel() {
			return onRampPositionWheel();
		},

		set onRampPositionWheel($$value = () => undefined) {
			onRampPositionWheel($$value);
			$.flush();
		},

		get shouldSuppressRampClick() {
			return shouldSuppressRampClick();
		},

		set shouldSuppressRampClick($$value = () => false) {
			shouldSuppressRampClick($$value);
			$.flush();
		}
	};

	var div = root_4();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);
	var text = $.only_child(div_2, true);
	var div_3 = $.sibling(div_2, 2);
	var node = $.child(div_3);

	Button(node, {
		variant: 'secondary',
		get handlePress() {
			return onAddRamp();
		},

		get disabled() {
			return maxRampsReached();
		},

		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_1 = $.text();

			$.template_effect(() => $.set_text(text_1, addRampLabel()));
			$.append($$anchor, text_1);
		},
		$$slots: { default: true }
	});

	var node_1 = $.sibling(node, 2);

	{
		var consequent = ($$anchor) => {
			{
				const trigger = ($$anchor) => {
					var span = root();

					$.append($$anchor, span);
				};

				const children = ($$anchor, closeMenu = $.noop) => {
					var fragment_2 = root_1();
					var button = $.first_child(fragment_2);
					var text_2 = $.only_child(button, true);
					var button_1 = $.sibling(button, 2);
					var text_3 = $.only_child(button_1, true);

					$.template_effect(() => {
						button.disabled = maxRampsReached();
						$.set_text(text_2, duplicateRampLabel());
						$.set_text(text_3, invertRampLabel());
					});

					$.delegated('click', button, () => {
						closeMenu()();
						onDuplicateSelectedRamp()();
					});

					$.delegated('click', button_1, () => {
						closeMenu()();
						onInvertSelectedRamp()();
					});

					$.append($$anchor, fragment_2);
				};

				DropdownMenu($$anchor, {
					wrapperClass: 'lut-editor-menu-wrap',
					menuClass: 'ui-menu lut-editor-menu-panel lut-editor-kebab-menu',
					triggerClassName: 'ui-menu-trigger',
					triggerVariant: 'menu-trigger',
					get triggerAriaLabel() {
						return rampMenuAriaLabel();
					},
					menuRole: 'menu',
					floating: true,
					trigger,
					children,
					$$slots: { trigger: true, default: true }
				});
			}
		};

		$.if(node_1, ($$render) => {
			if (selectedRamp()) $$render(consequent);
		});
	}

	$.reset(div_3);
	$.reset(div_1);

	var div_4 = $.sibling(div_1, 2);

	$.each(div_4, 23, ramps, (ramp) => ramp.id, ($$anchor, ramp, index) => {
		var div_5 = root_2();
		var div_6 = $.child(div_5);
		var span_1 = $.sibling(div_6, 2);
		var text_4 = $.only_child(span_1);
		var node_2 = $.sibling(span_1, 2);

		{
			var consequent_1 = ($$anchor) => {
				Button($$anchor, {
					variant: ["destructive", "small"],
					handlePress: () => onRemoveRamp()($.get(ramp).id),
					children: ($$anchor, $$slotProps) => {
						$.next();

						var text_5 = $.text();

						$.template_effect(() => $.set_text(text_5, removeRampLabel()));
						$.append($$anchor, text_5);
					},
					$$slots: { default: true }
				});
			};

			var d = $.derived(() => canRemoveRamp()($.get(ramp).id));

			$.if(node_2, ($$render) => {
				if ($.get(d)) $$render(consequent_1);
			});
		}

		$.reset(div_5);

		$.template_effect(
			($0, $1, $2) => {
				$.set_attribute(div_5, 'data-ramp-id', $.get(ramp).id);
				$.set_class(div_5, 1, $0, 'svelte-19kimso');
				$.set_style(div_6, $1);
				$.set_text(text_4, `${rampPositionLabel() ?? ''}: ${$2 ?? ''}%`);
			},
			[
				() => $.clsx(`ramp-row ${selectedRampId() === $.get(ramp).id ? 'ramp-row-selected' : ''} ${draggingRampListIdx() === $.get(index) ? 'ramp-row-dragging' : ''}`.trim()),
				() => rampSwatchStyle()($.get(ramp)),
				() => formatPositionPercent($.get(ramp).position)
			]
		);

		$.delegated('pointerdown', div_5, (event) => onStartRampListDrag()($.get(index), event));

		$.delegated('click', div_5, () => {
			if (!shouldSuppressRampClick()()) {
				onSelectRamp()($.get(ramp).id);
			}
		});

		$.append($$anchor, div_5);
	});

	$.reset(div_4);

	var node_3 = $.sibling(div_4, 2);

	{
		var consequent_2 = ($$anchor) => {
			var div_7 = root_3();
			var label = $.child(div_7);
			var text_6 = $.only_child(label, true);
			var input = $.sibling(label, 2);

			$.remove_input_defaults(input);
			$.bind_this(input, ($$value) => $.set(rampPositionInputRef, $$value), () => $.get(rampPositionInputRef));
			$.next(2);
			$.reset(div_7);

			$.template_effect(
				($0) => {
					$.set_text(text_6, rampPositionLabel());
					$.set_value(input, $0);
				},
				[
					() => editingRampPositionId() === selectedRamp().id
						? rampPositionDraft()
						: formatPositionPercent(selectedRamp().position)
				]
			);

			$.event('focus', input, () => {
				onBeginRampPositionEdit()(selectedRamp().id, formatPositionPercent(selectedRamp().position));
				scheduleSelectAllTextIfFocused($.get(rampPositionInputRef) ?? undefined);
			});

			$.delegated('input', input, (event) => onRampPositionInput()(selectedRamp().id, event.currentTarget.value));
			$.event('blur', input, () => onCommitRampPosition()(selectedRamp().id));

			$.delegated('keydown', input, (event) => {
				if (event.key === 'Enter') {
					event.currentTarget.blur();
				} else if (event.key === 'Escape') {
					onCancelRampPositionEdit()(formatPositionPercent(selectedRamp().position));
					event.currentTarget.blur();
				}
			});

			$.event('wheel', input, (event) => onRampPositionWheel()(selectedRamp().id, selectedRamp().position, event));
			$.append($$anchor, div_7);
		};

		$.if(node_3, ($$render) => {
			if (selectedRamp()) $$render(consequent_2);
		});
	}

	$.reset(div);
	$.template_effect(() => $.set_text(text, rampListLabel()));
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click', 'pointerdown', 'input', 'keydown']);

$.create_custom_element(
	Lut_editor_ramp_section,
	{
		ramps: {},
		selectedRamp: {},
		selectedRampId: {},
		editingRampPositionId: {},
		rampPositionDraft: {},
		draggingRampListIdx: {},
		rampListLabel: {},
		addRampLabel: {},
		duplicateRampLabel: {},
		invertRampLabel: {},
		removeRampLabel: {},
		rampPositionLabel: {},
		rampMenuAriaLabel: {},
		maxRampsReached: {},
		canRemoveRamp: {},
		rampSwatchStyle: {},
		onAddRamp: {},
		onSelectRamp: {},
		onStartRampListDrag: {},
		onRemoveRamp: {},
		onDuplicateSelectedRamp: {},
		onInvertSelectedRamp: {},
		onBeginRampPositionEdit: {},
		onRampPositionInput: {},
		onCommitRampPosition: {},
		onCancelRampPositionEdit: {},
		onRampPositionWheel: {},
		shouldSuppressRampClick: {}
	},
	[],
	[],
	{ mode: 'open' }
);